module.exports = __webpack_public_path__ + "img/phonehome.91d914dc.png";